import { SanityPage } from '~/types';

export const useFetchPreviewPage = async (): Promise<SanityPage | null> => {
  const sanity = useSanity();
  const {
    query: { documentId }
  } = useRoute();
  const { sanityPreviewToken } = useRuntimeConfig();

  // Drafts need the token and must skip the API CDN. The token is only available on the server,
  // and the Sanity helper is created per request, so this does not affect other visitors.
  if (process.server && sanityPreviewToken) {
    sanity.config.useCdn = false;
    sanity.setToken(sanityPreviewToken as string);
  }

  const { data } = await useAsyncData<SanityPage>(documentId as string, () =>
    sanity.fetch('*[_id==$documentId][0]', { documentId })
  );

  return data.value;
};
